<svg class="w-4 h-4" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.169 1.338c.242.244.416.547.504.88C16 3.442 16 6 16 6s0 2.557-.327 3.783a1.962 1.962 0 0 1-1.38 1.389c-1.22.328-6.1.328-6.1.328s-4.879 0-6.1-.328a1.962 1.962 0 0 1-1.38-1.39C.387 8.558.387 6 .387 6s0-2.557.326-3.783A1.962 1.962 0 0 1 2.093.828C3.315.5 8.194.5 8.194.5s4.88 0 6.1.328c.332.09.634.267.876.51Zm-8.572 2.34v4.644L10.677 6l-4.08-2.321Z"
    fill="currentColor" />
</svg>